import {
  Approve,
  Delete,
  Details,
  Edit,
  PdfDownload,
  Root,
  StarAction,
  View,
} from './components';

export const ActionsCell = {
  Root,
  Details,
  Edit,
  Approve,
  Delete,
  PdfDownload,
  StarAction,
  View,
};
